import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Subscription, filter, first } from "rxjs";
import { SessionService } from "../../../services/Session.service";
import { ActiveAlarmsPopupComponent } from "../../../../alarms/components/active-alarms-popup/active-alarms-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { CatalogPaginationRequest } from "../../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../../models/Filter/FilterRequest";
import { MiniMapService } from "../../../services/MiniMap.service";
import { SwalNotificationService } from "../../../services/SwalNotification.service";
import { LogService } from "../../../services/ServiceCatalogEncapsulators/Logs.service";
import { GenericTableService } from "../services/Generic-Table.service";

@Component({
  selector: "generic-table",
  templateUrl: "./generic-table.component.html",
  styleUrls: ["./generic-table.component.css"],
})
export class GenericTableComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() tableData;
  @Input() columnHeader;
  @Input() service;
  @Input() controllerName;
  @Input() filterOptions: { [key: string]: string[] };
  @Input() hasInactives: boolean = true;
  @Input() hasEditables: boolean = true;
  @Input() hasDeletables: boolean = true;
  @Input() catalogPaginationRequest: CatalogPaginationRequest;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) mainPaginator!: MatPaginator;
  @ViewChild(MatPaginator) noFilterPaginatorBackup!: MatPaginator;


  objectKeys = Object.keys;
  mainDataSource: MatTableDataSource<any>;
  noFilterDataSourceBackup: MatTableDataSource<any>;
  public isLoading = true;
  routeAdd: string;
  routeUpdate: string;
  routeDelete: string;
  mainTotalCount: number;
  filterTotal: number;
  pagina: number = 1;
  filterPage: number = 1;
  filterValue: string = "";
  isInactive: boolean = false;
  filtroInput: string = "";
  currentColumn: string;
  filterSearchText: string = '';

  subscription_GetLoading: Subscription;
  subscription_getPage: Subscription;
  subscription_getFilterCount: Subscription;
  subscription_delete: Subscription;
  subscription_getLogById: Subscription;
  constructor(
    private genericTableService: GenericTableService,
    private notifyService: SwalNotificationService,
    private router: Router,
    private sessionService: SessionService,
    private dialog: MatDialog,
    private miniMapService: MiniMapService,
    private logService: LogService
  ) {
    // this.subscription_GetLoading = this.genericTableService
    //   .getLoading()
    //   .subscribe((data: boolean) => {
    //     this.isLoading = data;
    //   });
  }

  ngOnInit() {
    this.isLoading = true;
  }

  ngAfterViewInit() {
    this.routeAdd = "/" + this.controllerName + "/add";
    this.routeUpdate = "/" + this.controllerName + "/update";
    this.routeDelete = "/" + this.controllerName + "/DeleteUser";
  }

  ngOnDestroy() {
    if (this.subscription_getPage) 
      this.subscription_getPage.unsubscribe();
    if (this.subscription_getFilterCount) 
      this.subscription_getFilterCount.unsubscribe();
    if (this.subscription_delete) 
      this.subscription_delete.unsubscribe();
    if (this.subscription_getLogById) 
      this.subscription_getLogById.unsubscribe();
  }

  public setData(data, mainTotalCount) {
    console.log("Data tabla", data, mainTotalCount);

    this.mainTotalCount = mainTotalCount;
    this.mainPaginator.length = this.mainTotalCount;
    this.tableData = this.GetCapitalizedKeys(data);
    this.tableData = this.tableData.filter(obj => obj.status != "Eliminado");
    this.mainDataSource = new MatTableDataSource(this.tableData);
    this.mainDataSource.paginator = this.mainPaginator;
    this.mainDataSource.sort = this.sort;
    this.isLoading = false;
    this.noFilterDataSourceBackup = this.mainDataSource;
    this.noFilterPaginatorBackup = this.mainPaginator;

    console.log("Data", this.mainDataSource);
    
  }

  GetCapitalizedKeys(data){
    return data.map(item => {
      const transformedItem = {};
      Object.keys(item).forEach(key => {
        transformedItem[key.charAt(0).toUpperCase() + key.slice(1)] = item[key];
      });
      return transformedItem;
    });
  }

  async nextPage(event){
    //revisa si va a traer datos filtrados
    if( (this.catalogPaginationRequest.dato != null && this.catalogPaginationRequest.dato != "") || this.catalogPaginationRequest.filters.length > 0){
      if ((event.pageIndex + 1) > this.filterPage){
        this.isLoading = true;
        this.catalogPaginationRequest.page = (event.pageIndex + 1);
        await this.UpdatePage();
        this.mainPaginator.length = this.filterTotal;
        this.mainDataSource.paginator = this.mainPaginator;
        this.mainDataSource.sort = this.sort;
        setTimeout(() => {
          this.mainPaginator.length = this.filterTotal;
        });
        this.isLoading = false;
        this.filterPage++;
      }
    }else{
      if ((event.pageIndex + 1) > this.pagina ){
        this.isLoading = true;
        this.catalogPaginationRequest.page = (event.pageIndex + 1);
        await this.UpdatePage();
        this.mainPaginator.length = this.mainTotalCount;
        this.mainDataSource.paginator = this.mainPaginator;
        this.mainDataSource.sort = this.sort;
        setTimeout(() => {
          this.mainPaginator.length = this.mainTotalCount;
        });
        this.isLoading = false;

        this.noFilterDataSourceBackup = this.mainDataSource;
        this.noFilterPaginatorBackup = this.mainPaginator;
        this.pagina++;
      }
      
    }
  }

  UpdatePage(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.subscription_getPage = this.service.getPage(this.catalogPaginationRequest).subscribe({
        next: (data) => {
          if (data.isSuccess) {
            var nuevosDatos = data.result.filter(obj => obj.status !== "Eliminado");
  
            nuevosDatos.forEach(item => {
              item['IsEditable'] = this.hasEditables;
              item['IsDeletable'] = (item['status'] === 'Activo' && this.hasDeletables);
            });
  
            var capitalizedNewData = this.GetCapitalizedKeys(nuevosDatos);
            this.mainDataSource = new MatTableDataSource(this.mainDataSource.data.concat(capitalizedNewData));
            resolve();
          } else {
            this.notifyService.MessageError("Error en la carga de datos");
            this.isLoading = false;
            reject("Error en la carga de datos");
          }
        },
        error: (err) => reject(err)
      });
    });
  }

  async applyFilter(event : any = null) {
    var keyPressed = null;
    if (event != null){
      keyPressed = event.code;
    }else{
      keyPressed = "Enter";
    }
    if (keyPressed != "Enter" && this.filtroInput.length > 0)
      return;
    
    this.isLoading = true;
    if (this.filtroInput.length >= 2) {
        //se actualiza el request de paginacion
        this.catalogPaginationRequest.page = 1;
        this.catalogPaginationRequest.dato = this.filtroInput;
        //se realiza la peticion
        await this.GetFilterFirstPage();
    }
    else{
      this.catalogPaginationRequest.dato = "";
      if (this.catalogPaginationRequest.filters.length > 0 || this.isInactive) {
        await this.GetFilterFirstPage();
      }else{
        this.removeFilter();
      }
      this.isLoading = false;
    }
    if (this.mainDataSource.paginator)
      this.mainDataSource.paginator.firstPage();
    
  } 

  GetInactives(){
    this.isInactive = !this.isInactive;
    this.catalogPaginationRequest.getInactive = this.isInactive;
    this.applyFilter();
  }

  async GetFilterFirstPage(){
    this.subscription_getFilterCount = this.service.getCount(this.catalogPaginationRequest).subscribe(data=>{
      if (data.isSuccess == true) {
        this.filterTotal = data.result[0];
      }
    });
    this.mainDataSource = new MatTableDataSource([]);
    await this.UpdatePage();
    this.mainDataSource.paginator = this.mainPaginator;
    this.mainDataSource.sort = this.sort; 
    setTimeout(() => {
      this.mainPaginator.length = this.filterTotal;
    });
    this.isLoading = false;
    this.filterPage = 1;
  }

  removeFilter(){
    const filterValue = this.filtroInput;
    if (filterValue.length == 0) {
      this.isLoading = true;
      this.mainDataSource = this.noFilterDataSourceBackup;
      this.mainPaginator = this.noFilterPaginatorBackup;
      setTimeout(() => {
        this.mainPaginator.length = this.mainTotalCount;
      });
      this.filterPage = 0;
    }
    this.isLoading = false;
    if (this.mainDataSource.paginator) {
      this.mainDataSource.paginator.firstPage();
    }
  }
  

  refreshFilter(){
    this.filtroInput = "";
    this.catalogPaginationRequest.dato = "";
    this.catalogPaginationRequest.filters = [];
    this.applyFilter();
  }

  setCurrentColumn(column: string) {
    this.currentColumn = column;
  }

  applyColumnFilter(value: string) {
    const filter: FilterRequest = { key: this.currentColumn, value: value };
    var currentFilter = this.catalogPaginationRequest.filters.find(filter => filter.key === this.currentColumn);
    if (currentFilter) {
      currentFilter.value = value;
    }
    else {
      this.catalogPaginationRequest.filters.push(filter);
    }
    this.columnHeader[this.currentColumn].activeFilter = value;
    this.applyFilter();
  }

  // applyColumnFilter(value: string, column: string) {
  //   const filter: FilterRequest = { key: column, value: value };
  //   const currentFilter = this.catalogPaginationRequest.filters.find(filter => filter.key === column);
  //   if (currentFilter) {
  //     currentFilter.value = value;
  //   } else {
  //     this.catalogPaginationRequest.filters.push(filter);
  //   }
  //   this.columnHeader[column].activeFilter = value;
  //   this.applyFilter();
  // }

  clearColumnFilter() {
    this.catalogPaginationRequest.filters = this.catalogPaginationRequest.filters.filter(filter => filter.key !== this.currentColumn);
    this.columnHeader[this.currentColumn].activeFilter = null;
    this.applyFilter();
  }

  handleClick(row, eventType) {
    if(eventType == 'edit'){
      console.log(row);
      var url = this.router.serializeUrl(this.router.createUrlTree([this.routeUpdate],{queryParams: {Id: row.Id}}));
      // window.location.href = '#'+url;
      window.open('#' + url, '_blank');
    // console.log(row, eventType);
    }
    if(eventType == 'delete'){
      var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar el registro?");
      resp.then((result) =>{
         if(result.value)
         {
        // window.open(urlb,'_blank');
        this.subscription_delete = this.service.delete(row.Id).subscribe((data)=>{
          console.log("Data ",data);
          if(data.isSuccess == true){
            this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
            this.sessionService.ReloadPage();
          }else{
            this.notifyService.MessageError("Problema al eliminar el registro");
          }
        });
      }
     });
    }

  if(eventType == 'details'){
    console.log(row);
    // this.service.getDetails().subscribe((data) => {
      
    // });
  }

  // if(resp)
  // {
  //   this.notifyService.MessageSuccessful("Borrado Exitoso","El usuario fue borrado exitosamente");
  // }
    // var url = this.router.serializeUrl(this.router.createUrlTree([this.routeDelete],{queryParams: {Id: row.Id}}));
    //   window.open('#'+url,'_blank');
    // console.log(row, eventType);
  }
  
  listPopUp(event){
    console.log(event.logDetails);
    this.notifyService.MessageDetails(event.logDetails);
  }

  alarmDetailPopUp(event){
    //si hay log, lo abre en una tabla, si no, abre los detalles con minimapa
    console.log(event);
    
    var idAlarm = event.Id;
    if (event.IdAlarm != null) {
      idAlarm = event.IdAlarm;
    }
    console.log(idAlarm);
    const dialogRef = this.dialog.open(ActiveAlarmsPopupComponent, {
      width: "auto",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
      data: {id: idAlarm}
    });
  
    dialogRef.afterClosed().subscribe(reload => {
      console.log('cerrado');
      this.miniMapService.deleteMap();
    });
  }

  alarmLogDetailPopUp(event){
    //si hay log, lo abre en una tabla
    if (event.IdLog != null && event.IdLog != 0) {
      this.isLoading = true;

      this.subscription_getLogById = this.logService.getById(event.IdLog).subscribe((data) => {
        if(data.isSuccess == true){
          this.notifyService.MessageDetailsAsTable(data.result);
          this.isLoading = false;
        }else{
          this.notifyService.MessageError("Error al cargar los detalles del log");
          this.isLoading = false;
        }
      });

    }else{
      this.notifyService.MessageError("No hay detalles del log, revisar id");
      this.isLoading = false;
      return;
    }
  }

}
